import React from "react";
import styled from "styled-components";

const Lightbox = () => {
  return <Wrapper></Wrapper>;
};

const Wrapper = styled.div``;

export default Lightbox;
